import './header.scss';
var Header = function Header(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle;
  return /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-body"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "header-title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "header-subtitle"
  }, subtitle)));
};
Header.defaultProps = {
  title: '',
  subtitle: ''
};
export default Header;